"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.uploadReducer = void 0;
var tslib_1 = require("tslib");
/*
The way upload works is a bit unorthodox.  The problem is that we need to watch when the upload finishes.
The reducer is used to queue the upload jobs and the UploadWatcher component is used to dispatch when the job is done.
*/
var uploadReducer = function (state, action) {
    if (!action) {
        return state || null;
    }
    if (action.type === 'UPLOAD_REQUEST') {
        return tslib_1.__assign(tslib_1.__assign({}, state), action.requestValues);
    }
    if (action.type === 'UPLOAD_UPDATE_ACTION') {
        var clone = tslib_1.__assign({}, state);
        clone[action.uploadId] = tslib_1.__assign(tslib_1.__assign({}, clone[action.uploadId]), action.values);
        return clone;
    }
    if (action.type === 'UPLOAD_SUCCESS') {
        return tslib_1.__assign(tslib_1.__assign({}, state), action.successValues);
    }
    if (action.type === 'UPLOAD_FAILURE') {
        return tslib_1.__assign(tslib_1.__assign({}, state), action.failureValues);
    }
    if (action.type === 'UPLOAD_CLEAR') {
        if (state && action.uploadId) {
            var newState = tslib_1.__assign({}, state);
            delete newState[action.uploadId];
            return newState;
        }
        else {
            return null;
        }
    }
    return state || null;
};
exports.uploadReducer = uploadReducer;
